import React from 'react';
import ExceptionAlerts from './ExceptionAlerts';
import ProcurementForesight from './ProcurementForesight';

const ExceptionView = ({ procurementForesight, emergencyPurchases, excessConsumption }) => {
    return (
        <div className="flex flex-col xl:flex-row gap-6 h-full">
            <div className="w-full xl:w-[40%]">
                <ExceptionAlerts emergencyPurchases={emergencyPurchases} excessConsumption={excessConsumption} />
            </div>
            <div className="w-full xl:w-[60%]">
                <ProcurementForesight procurementForesight={procurementForesight} />
            </div>
        </div>
    );
};

export default ExceptionView;
